import React, { useEffect } from "react";
import { Router } from "react-router-dom";

import LoadingBar from "../../components/LoadingBar";
import Alert from "../../components/Alert";
import { history } from "../../helpers";
import { webkitHelper } from "../../helpers";
import ScrollToTop from "../../components/ScrollToTop";
import HtmlLocale from "../../components/HtmlLocale";
import ErrorBoundary from "../../components/ErrorBoundary";

import { routes } from './routes'

import "./index.scss";
import { VersionChecker } from "./VersionChecker";
import PageTitle from "../../components/Common/PageTitle";
import InitSession from "./init-session";
import CrosstabWarning from "./crosstab-warning"

export default function App() {

  useEffect(() => {
    const unlisten = history.listen((location) => {
      //console.log(`change location: ${action}`, location, this.prevLocation);
      if (location.pathname) {
        webkitHelper.sendCurrentLocation(location.pathname);
      }
    })

    return () => {
      unlisten();
    }
  }, [])

  return (
    <>
      <VersionChecker />
      <Router history={history}>
        <HtmlLocale className="in-mobile">
          <PageTitle title="SalamAir | Book A Flight" />
          <InitSession>
            <ScrollToTop>
                <ErrorBoundary name="app">
                  {routes}
                </ErrorBoundary>
              <LoadingBar />
              <Alert />
            </ScrollToTop>
          </InitSession>
        </HtmlLocale>
        <CrosstabWarning />
      </Router>
    </>
  );
}

